package io.horion.cv.models

import io.horion.cv.components.forms.DownPageForm
import io.horion.cv.components.forms.PersonalizedCompetencesForm
import io.horion.cv.components.forms.PersonalizedDescriptionForm
import io.horion.cv.components.forms.PersonalizedEntriesForm
import io.horion.cv.components.forms.PersonalizedListForm
import io.horion.cv.components.forms.RealisationForm
import io.horion.cv.components.forms.SignatureForm
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

val extraSectionsCatalog = listOf(
    ExtraSection(
        id = "cours",
        title = "Cours",
        collapsedWidth = 115.px,
        content = { }
    ),
    ExtraSection(
        id = "certificats",
        title = "Certificats",
        collapsedWidth = 160.px,
        content = {}
    ),
    ExtraSection(
        id = "references",
        title = "Références",
        collapsedWidth = 170.px,
        content = {}
    ),
    ExtraSection(
        id = "stage",
        title = "Stages",
        collapsedWidth = 125.px,
        content = { }
    ),
    ExtraSection(
        id = "realisations",
        title = "Réalisations",
        collapsedWidth = 170.px,
        content = { RealisationForm() }
    ),
    ExtraSection(
        id = "signature",
        title = "Signature",
        collapsedWidth = 155.px,
        content = { SignatureForm() }
    ),
    ExtraSection(
        id = "bas-de-page",
        title = "Bas de page",
        collapsedWidth = 175.px,
        content = { DownPageForm() }
    ),
)

fun createPersonalizedSection(
    type: PersonalizedSectionType,
    counter: Int,
    cvViewModel: CvViewModel
): ExtraSection {
    val sectionId = "rubrique-$counter"

    val descriptionState =
        if (type == PersonalizedSectionType.DESCRIPTION) {
            DescriptionState(sectionId)
        } else {
            null
        }

    return ExtraSection(
        id = sectionId,
        title = defaultTitleFor(type),
        collapsedWidth = 300.px,
        personalizedType = type,
        descriptionState = descriptionState,
        content = {
            when (type) {
                PersonalizedSectionType.DESCRIPTION ->
                    PersonalizedDescriptionForm(
                        state = descriptionState!!,
                        cvViewModel = cvViewModel
                    )

                PersonalizedSectionType.ENTRIES ->
                    PersonalizedEntriesForm(
                        sectionId = sectionId,
                        cvViewModel = cvViewModel
                    )

                PersonalizedSectionType.COMPETENCES ->
                    PersonalizedCompetencesForm(
                        sectionId = sectionId,
                        cvViewModel = cvViewModel
                    )

                PersonalizedSectionType.LIST ->
                    PersonalizedListForm(
                        sectionId = sectionId,
                        cvViewModel = cvViewModel
                    )
            }
        }
    )
}